const { colors } = require('../fragments/fragments');
export const isBrowser = typeof window !== 'undefined';
export const isInternalLink = (link, externalRoutes) => !new RegExp(`(^[A-Za-z])${externalRoutes.length > 0
    ? `|(^\\/(${externalRoutes.join('|')})(\\/|\\?|$))`
    : ''}`).test(link);
export const capitalize = (string) => string
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
export const truncate = (input, value) => input.length > value ? `${input.substring(0, value)}…` : input;
export const getColorFromColorType = (color, defaultValue = colors.nebula) => {
    if (color) {
        const formattedColorArray = color.split('-');
        const prefix = formattedColorArray[0];
        if (formattedColorArray.length === 2) {
            const index = formattedColorArray[1];
            return colors[prefix][index];
        }
        return colors[prefix];
    }
    return defaultValue;
};
export const slugify = (item) => item
    .replace(/\s/g, '-')
    .replace(/[^\w-]/g, '')
    .replace(/-+/g, '-')
    .replace(/(-?\s*)$/g, '')
    .toLowerCase();
export const isVideoEmbed = (url) => {
    if (url.includes('play.vidyard.com'))
        return 'vidyard';
    if (url.includes('player.vimeo.com'))
        return 'vimeo';
    if (url.includes('www.youtube.com/embed'))
        return 'youtube';
    return false;
};
export const removeOverflowHiddenBody = () => document.body.classList.remove('uil-ov-hidden');
export const getUrl = (to, externalRoutes, withUrlPrefix) => {
    const isInternal = isInternalLink(to, externalRoutes);
    if (isInternal || !to.includes('https')) {
        return withUrlPrefix ? `https://www.algolia.com${to}` : to;
    }
    return to;
};
